import FlutterServicesAPI from '../../../services/flutterServices';

export const faqData = [
    {
        id: 1,
        title: '<span class="font-montserrat">A</span>BOUT GLAMMIFY',
        questions: [
            {
                id: 1,
                question: '1. What is Glammify?',
                answer: '<p>Glammify is an AI-powered product modeling platform that transforms your jewelry, apparel, footwear, and accessory images into stunning visuals using lifelike mannequins or human models, no photo shoot required.</p>',
            },
            {
                id: 2,
                question: '2. Who is Glammify for?',
                answer: `<p>Glammify is designed for:</p>
                <ul>
                    <li>Jewelry brands</li>
                    <li>Apparel & fashion boutiques</li>
                    <li>Footwear and accessories sellers</li>
                    <li>eCommerce platforms and marketplaces</li>
                </ul>`,

            },
            {
                id: 3,
                question: '3. How does Glammify work?',
                answer: '<p>You upload your product image, choose your preferred model type (mannequin or human), select gender, ethnicity, output format (image, GIF, or video), and Glammify generates realistic visuals using advanced AI, all in a minute.</p>'
            },
        ],
    },
    {
        id: 2,
        title: 'USING GLAMMIFY',
        questions: [
            {
                id: 1,
                question: '4. What kinds of outputs can I generate?',
                answer: `<p>You can create:</p>
                <ul>
                    <li>Product-on-Mannequin (Image)</li>
                    <li>Product-on-Model (Image)</li>
                    <li>Product-on-Mannequin (GIF/Video)</li>
                    <li>Product-on-Model (GIF/Video)</li>
                </ul>`,
            },
            {
                id: 2,
                question: '5. Do I need any design or editing skills?',
                answer: 'No, Not at all! Glammify is built for ease of use. Just upload your product image, configure a few options, and let our AI handle the rest.',
            },
            {
                id: 3,
                question: '6. Can I choose the model’s appearance?',
                answer: `<p>Yes! You can customize:</p>
                <ul>
                    <li>Ethnicity</li>
                    <li>Output format (static image or video)</li>
                </ul>`,
            },
            {
                id: 4,
                question: `7. Can I preview the output before spending ${FlutterServicesAPI.getCreditLabel().toLowerCase()}?`,
                answer: `<p>At this time, previews are not available before generating the final output. However, if you’re not satisfied with the result, you can rate the output and share feedback directly within the platform. Our team reviews all submissions, and if the output does not meet quality expectations, we’ll refund the ${FlutterServicesAPI.getCreditLabel().toLowerCase()} for that specific creative — no questions asked.</p>`,
            },

        ],


    },
    {
        id: 3,
        title: `${FlutterServicesAPI.getCreditLabel().toUpperCase()} & PRICING`,
        questions: [
            {
                id: 1,
                question: `8. What is the ${FlutterServicesAPI.getCreditLabel().toLowerCase()} system?`,
                answer: `<p>Glammify uses a simple and flexible ${FlutterServicesAPI.getCreditLabel().toLowerCase()}-based system. You purchase ${FlutterServicesAPI.getCreditLabel().toLowerCase()} and redeem them each time you generate a visual — whether it’s an image or video, on a mannequin or a lifelike human model. Different output types require different amounts of ${FlutterServicesAPI.getCreditLabel().toLowerCase()}, depending on the complexity and format. </p>
        <p>The more ${FlutterServicesAPI.getCreditLabel().toLowerCase()} you purchase, the more value you unlock — with bonus ${FlutterServicesAPI.getCreditLabel().toLowerCase()} and exclusive features in higher-tier plans. It’s pay-as-you-go, with full control in your hands</p>`,
            },
            {
                id: 2,
                question: `9. How can I buy ${FlutterServicesAPI.getCreditLabel().toLowerCase()}?`,
                answer: `<p class="">You can currently purchase ${FlutterServicesAPI.getCreditLabel().toLowerCase()} by reaching out to our team — we’ll guide you through a quick and easy offline payment process. Simply contact our support team through the dashboard or email us at <a class="text-decoration-none " href="mailto:support@glammify.ai">support@glammify.ai</a> to get started</p>
        <p class="">We’re also launching online ${FlutterServicesAPI.getCreditLabel().toLowerCase()} purchases with secure payment gateway integration very soon, so you’ll be able to top up anytime, instantly.</p>
        <p class="">Pro Tip: The more you invest, the more you gain — our higher-tier ${FlutterServicesAPI.getCreditLabel().toLowerCase()} bundles offer bonus ${FlutterServicesAPI.getCreditLabel().toLowerCase()}, effectively reducing your cost per creative and giving you more value for your spend. Perfect for growing brands and bulk users!</p>
        <p class="">Ready to scale your visual content? Reach out now and let’s get you started.</p>
        `,
            },
            {
                id: 3,
                question: `10. Do unused ${FlutterServicesAPI.getCreditLabel().toLowerCase()} expire?`,
                answer: `<p>Yes, ${FlutterServicesAPI.getCreditLabel().toLowerCase()} expire based on the plan validity. Make sure to use them within the active period.</p>`,
            },
            {
                id: 4,
                question: `11. Can I top up ${FlutterServicesAPI.getCreditLabel().toLowerCase()} anytime?`,
                answer: `<p>Absolutely. You can purchase additional ${FlutterServicesAPI.getCreditLabel().toLowerCase()} anytime by contacting <a href="mailto:sales@glammify.ai">sales@glammify.ai</a> or through your dashboard by paying online.</p>`,
            },
            {
                id: 5,
                question: `12. Can I get a refund for unused ${FlutterServicesAPI.getCreditLabel().toLowerCase()}?`,
                answer: `<p>${FlutterServicesAPI.getCreditLabel()} are non-refundable. However, you can use them across different product types and outputs.</p>`,
            },


        ],
    },
    {
        id: 4,
        title: 'INTEGRATIONS & <span class="font-montserrat">A</span>PI',
        questions: [
            {
                id: 1,
                question: '13. Can I integrate Glammify with my website or app?',
                answer: '<p>Yes! We offer API and plugin support for Shopify, WooCommerce, Magento and more. Contact our sales team for integration options.</p>',
            },
            {
                id: 2,
                question: '14. Do you offer bulk processing or automation?',
                answer: '<p>Yes, we support bulk product uploads and batch processing for enterprise clients. Get in touch to activate this feature.</p>',
            },

        ],
    },
    {
        id: 5,
        title: '<span class="font-montserrat">A</span>CCOUNT & SUPPORT',
        questions: [
            {
                id: 1,
                question: '15. How do I create an account?',
                answer: '<p> Just click on “Sign Up” at the top right of the homepage and follow the quick registration process.</p>',
            },
            {
                id: 2,
                question: '16. I’m facing issues with output quality. What should I do?',
                answer: `<p>We’re here to help! Before reaching out, we recommend checking our Image Upload Guidelines to ensure your input image meets the best standards for lighting, clarity, background, and product orientation. Many output issues can be resolved with a better-quality input.</p>
                <p>If you’ve followed the guidelines and are still not satisfied with the result, you can:</p>
                <ul>
                    <li>Submit feedback with a star rating directly on the creative</li>
                    <li>Or contact our team at <a href="mailto:support@glammify.ai">support@glammify.ai</a></li>
                </ul>
                <p>We’ll review your case and work with you to ensure you get the best possible output — and we may even refund ${FlutterServicesAPI.getCreditLabel().toLowerCase()} if the output doesn’t meet expectations.</p>    `,
            },
            {
                id: 3,
                question: '17. Is there any customer support available?',
                answer: '<p>Yes! Our team is available via chat and email Monday to Saturday, 10 AM – 9 PM IST.</p>',
            },



        ],
    },
    {
        id: 6,
        title: 'GETTING STARTED',
        questions: [
            {
                id: 1,
                question: `18. I'm new, how do I start?`,
                answer: `<ul>
                <li>Sign up for free</li>
                <li>Get free ${FlutterServicesAPI.getCreditLabel().toLowerCase()} once your account is verified</li>
                <li>Upload your first product image</li>
                <li>Generate and download AI-enhanced visuals</li>
                <li>Upgrade when you're ready to scale!</li>
                </ul>`,
            },

            {
                id: 2,
                question: '19. Can I request a demo or onboarding help?',
                answer: '<p>Of course! Drop us a message at <a href="mailto:support@glammify.ai">support@glammify.ai</a> or use the “Book a Demo” link on our homepage.</p>',
            },

        ],
    },
];